import ListMenu from "../../../Common/ListMenu";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useDispatch, useSelector } from "react-redux";
import {
  setEditSchedule,
  setScheduleInformation,
  toggleBuildSchedulePopup,
} from "../../../Redux/Actions/LoginActions";
import {
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../../utils/constant";
export const ScheduleTableAction = ({ row }) => {
  const dispatch = useDispatch();
  const permissionRights = useSelector(({ loggedInUser }) =>
    loggedInUser.userProfile.permissionRights.map((item) => item.displayName)
  );
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      role: role,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
      permissionRights: loggedInUser.userProfile.permissionRights.map(
        (item) => item.displayName
      ),
    };
  });
  const menuItemContent = () => {
    const arr = [
      {
        id: "1",
        name: "Edit Details",
        icon: <ModeEditIcon className="manage-section-iconss" />,
        ApiCall: EditDetails,
      },
    ];
    return arr;
  };

  const EditDetails = (param) => {
    setScheduleInformation(dispatch, param);
    setEditSchedule(dispatch, true);
    toggleBuildSchedulePopup(dispatch, true);
  };

  return (
    <div>
      {(userInfo.role == userRoles.ROLE_SCHOOL_ADMIN ||
        permissionRights.includes("Add/ Remove Schedule")) && (
        <ListMenu menuContent={menuItemContent(row)} rowData={row} />
      )}
    </div>
  );
};
